<template>
  <div class="intro">
    <div class="intro__text">
      <h1 class="intro__text-heading">Břetislav Krejsa</h1>
      <h3 class="--color-pink">Urbanista - Architekt - Grafik</h3>
      <a href="#napiste-mi" class="btn btn-primary">Napište mi</a>
    </div>
    <img src="img/breta.svg" alt="Břetislav Krejsa" class="intro__image" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      focusLinks: [
        {
          src: "/img/up.svg",
          alt: "Územní plán",
          heading: "Urbanismus a<br>územní plánování",
          url: "/urbanismus",
        },
        {
          src: "/img/dum.svg",
          alt: "Rodinný dům",
          heading: "Architekrura",
          url: "/architektura",
        },
        {
          src: "/img/grafika.svg",
          alt: "Grafika",
          heading: "Fotografie a<br>grafický design",
          url: "/grafika",
        },
      ],
    };
  },
};
</script>
<style>
.intro {
  height: 90vh;
  grid-column: span 2;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
}

.intro__text-heading {
  margin: 0;
}

@media only screen and (max-width: 800px) {
  
  .intro__text {
    order: 2;
    grid-column: span 2;
    text-align: center;
  }
  .intro__image {
    grid-column: span 2;
    order: 1;
  }
}
</style>
